import React from 'react';
import styles from './css/SignIn.module.css';

const FloatingLabelInput = ({ type, value, onChange, label,isRequired  }) => {
    return (
        <div className={styles.input_wrapper}>
            <input
                type={type}
                value={value}
                onChange={onChange}
                required
                className={styles.signin_input}
                placeholder=" " /* Important: Keep this blank */
            />
            <label> 
                {label} {isRequired && <span style={{ color: 'red' }}>*</span>}
            </label>
        </div>
    );
};

export default FloatingLabelInput;
